import React from 'react';
import css from './ListingPageGo.css';

import { FormattedMessage } from 'react-intl';
import { InlineTextButton } from '../../../components';
import { ensureListing } from '../../../util/data';

const SectionHeading = props => {
  const {
    priceTitle,
    formattedPrice,
    richTitle,
    authorDisplayName,
    hostLink,
    category,
    showContactUser,
    onContactUser,
    currentListing,
    shouldShowPricePerMonth,
    isLongTerm,
    isDisinfected,
    isInstantBookingListing,
    isAllowedToBook = true,
  } = props;

  const { author } = ensureListing(currentListing);

  const instantBookingLabel =
    isInstantBookingListing && !shouldShowPricePerMonth && !isLongTerm ? (
      <div className={css.instantBooking}>
        <FormattedMessage id={'ListingPage.instantBookingLabel'} />
      </div>
    ) : null;

  const isDisinfectedLabel =
    isDisinfected ? (
      <div class={css.wrapperLabelDisinfected}>
        <div class={css.numberDays}>
          <div className={css.number}> 60 </div>
          <div className={css.day}> days</div>
        </div>
        <div class={css.textLabel}>
          <span> Disinfected </span>
        </div>
      </div>
    ) : null;

  return (
    <div className={css.sectionHeading}>
      <div className={css.heading}>
        <div className={css.labelGroup}>
          {instantBookingLabel}
          {isDisinfectedLabel}
        </div>
        
        <div className={css.author}>
          <InlineTextButton rootClassName={css.hostedByLinkDesktop}>
            <FormattedMessage id="ListingPage.hostedBy" values={{ name: hostLink || authorDisplayName }} />
          </InlineTextButton>
          {showContactUser && isAllowedToBook ? (
            <span className={css.contactWrapper}>
              <span className={css.separator}>•</span>
              <InlineTextButton rootClassName={css.contactLink} onClick={onContactUser}>
                <FormattedMessage id="ListingPage.contactUser" />
              </InlineTextButton>
            </span>
          ) : null}
        </div>
        <h1 className={css.title}>{richTitle}</h1>
        <div className={css.author}>
          <InlineTextButton rootClassName={css.hostedByLinkMobile}>
            {category} <FormattedMessage id="ListingPage.hostedBy" values={{ name: hostLink || authorDisplayName }} />
          </InlineTextButton>
        </div>
      </div>
    </div>
  );
};

export default SectionHeading;
